<template>
  <div class="container--productos">
    <div class="container--productos__name">
      <h1><strong>{{nombreProveedor}}</strong></h1>
    </div>
    <div class="container--productos__nav">
      <ul>
        <li>
          <router-link :to="`/tux/proveedores/${id}/productos`">
            <p>
            Consultar de productos
            </p>
          </router-link>
        </li>
        <li>
          <router-link :to="`/tux/proveedores/${id}/productos/alta`">
            <p>
            Alta de productos {{id}}
            </p>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="container--productos__body">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Productos',
  props: ['id'],
  data() {
    return {
      nombreProveedor: 'Coyote Ice.'
    }
  }
}
</script>

<style lang="sass">
.container--productos
  height: 100%
  display: grid
  grid-template-rows: 40px 40px 1fr
  .container--productos__name
    padding: 0 20px
    display: flex
    align-items: center
    font-size: 16px
    h1
      width: 100%
      font-size: 22px
      color: #02e079
  .container--productos__nav
    ul
      text-align: left
      padding: 0 20px
      display: flex
      flex-direction: row
      height: 100%
      li
        display: flex
        align-items: center
        padding-right: 40px

</style>
